import styled from "styled-components";

import HotspotLayout from "src/components/HotspotImage/HotspotLayout";
import SpottableImage from "src/components/HotspotImage/SpottableImage";
import font from "src/styles/font";

const S = {};

S.Container = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  margin-top: 24px;

  display: flex;
  flex-direction: column;
  align-items: center;
`;

S.BlogContent = styled.div`
  width: 100%;
  margin: 40px 0;
`;

S.BlogParagraph = styled.div`
  margin-bottom: 24px;

  h1 {
    display: block;
    font-size: 2rem;
    margin-block-start: 0.67em;
    margin-block-end: 0.67em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: bold !important;
  }

  h2 {
    display: block;
    font-size: 1.5rem;
    margin-block-start: 0.83em;
    margin-block-end: 0.83em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: bold !important;
  }

  h3 {
    display: block;
    font-size: 1.17rem;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: bold !important;
  }

  p {
    word-break: break-word;
    font-size: 1rem;
    display: block;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
  }

  b,
  strong {
    font-weight: bold !important;
  }

  span {
    font-weight: 400 !important;
  }

  a {
    font-weight: 500;
    text-decoration: underline;
    /* color: blue; */
  }

  blockquote {
    border-left: 5px solid #ccc;
    font-style: italic;
    margin-left: 0;
    margin-right: 0;
    overflow: hidden;
    padding-left: 1.5em;
    padding-right: 1.5em;
  }

  ol {
    list-style-type: decimal !important;
  }
`;

S.VideoEmbedContainer = styled.div`
  position: relative;
  padding-top: calc(100% / (16 / 9));
  display: flex;
  margin-bottom: 24px;
`;

S.YoutubeEmbed = styled.iframe`
  position: absolute;
  border: 0;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
`;

S.TikTokEmbed = styled.iframe`
  border: 0;
  width: 100%;
  height: 770px;
  margin-bottom: 24px;
`;

S.ContentElement = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  /* margin-top: 24px; */
  /* align-items: center; */
`;

const Step3 = ({ formControl, formData }) => {
  const contentRenderer = (element) => {
    let content_media;

    if (element.group_media.length !== 0) {
      // identify content type are media or link
      // if first element of group is media we assume all of the following elements to be media.
      const isMedia = element.group_media.some((item) => item.media);
      const isLink = element.group_media.some((item) => item.link);

      if (isMedia) {
        content_media = (
          <HotspotLayout layout={element.placement}>
            {element.group_media.map((item, index) => (
              <SpottableImage
                key={index}
                mode={"view-only"}
                aspectRatio={
                  element?.placement?.includes("square") ? 1 : 21 / 9
                }
                previewImage={
                  typeof item.media === "object"
                    ? URL.createObjectURL(item.media)
                    : item.media
                }
                hotspot={item.hotspot}
                formControl={formControl} // just for prevent error formControl is not defined in spottable image
              />
            ))}
          </HotspotLayout>
        );
      } else if (isLink) {
        const source = element.group_media[0].link.includes("tiktok")
          ? "tiktok"
          : "youtube";
        if (source === "tiktok") {
          content_media = (
            <S.TikTokEmbed
              src={element.group_media[0].link}
              allowfullscreen
              allow="encrypted-media;"
            />
          );
        } else if (source === "youtube") {
          content_media = (
            <S.VideoEmbedContainer>
              <S.YoutubeEmbed
                src={element.group_media[0].link}
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen
              />
            </S.VideoEmbedContainer>
          );
        }
      }
    }

    return (
      <>
        {content_media}
        {element.content_text && (
          <S.BlogParagraph
            dangerouslySetInnerHTML={{
              __html: element.content_text,
            }}
          ></S.BlogParagraph>
        )}
      </>
    );
  };

  return (
    <S.Container>
      <label style={{ fontSize: font.size.lg }}>ตัวอย่างบทความ</label>
      <S.BlogContent>
        {formData.contents.map((element, index) => (
          <S.ContentElement key={index}>
            {contentRenderer(element)}
          </S.ContentElement>
        ))}
      </S.BlogContent>
    </S.Container>
  );
};

export default Step3;
